import React from 'react';
import styled from 'styled-components';

/**
 * Блок отображается, если под фильтры не попал ни один оффер
 */
export const EmptyBlock = ({ children, isMobile = false }) => (
  <Container isMobile={isMobile}>
    <Block>{children}</Block>
  </Container>
);

const Container = styled.div<{ isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: var(--white);
  padding: ${({ isMobile }) => (isMobile ? '16px' : '24px 16px')};
  border-radius: var(--border-radius);
`;

const Block = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;
